import { z } from 'zod';

import { PASSWORD_POLICY_RE } from './password-policy';

// Field error messages are i18n keys; the form component re-translates via
// `t(errors.email.message)`. This keeps the schema lib-agnostic w.r.t. locale.
export const loginSchema = z.object({
  email: z
    .string()
    .min(1, 'validation:auth.email.required')
    .email('validation:auth.email.invalid'),
  password: z
    .string()
    // The empty case gets its own message and must be checked BEFORE the policy rule: the checks
    // run in the order written and the form shows the first issue, so putting the policy rule first
    // would answer "you left this blank" with an explanation of the character rules. This mirrors
    // the email field directly above it, whose required-then-format ordering was already correct.
    .min(1, 'validation:auth.password.required')
    .max(64, 'validation:auth.passwordLengthRule')
    .regex(PASSWORD_POLICY_RE, 'validation:auth.passwordRule'),
});

export type LoginFormValues = z.infer<typeof loginSchema>;
